import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/components/ButtonStyles.scss';
import noop from 'lodash/noop';

const PrimaryButton = ({ text, isDisabled, onClick, style, className, icon, loader }) => {
  let containerClass = `button-primary-container ripple ${className}`;
  if (isDisabled) containerClass += ' disabled';
  return (
    <div
      style={style}
      className={containerClass}
      onClick={() => {
        if (!isDisabled) onClick();
      }}
    >
      <div className="button-primary-text">
        {icon} {text} {loader}
      </div>
    </div>
  );
};
PrimaryButton.defaultProps = {
  text: '',
  isDisabled: false,
  onClick: noop,
  style: {},
  className: '',
  icon: null,
  loader: null,
};
PrimaryButton.propTypes = {
  text: PropTypes.string,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.instanceOf(Object),
  className: PropTypes.string,
  icon: PropTypes.node,
  loader: PropTypes.node,
};
export default PrimaryButton;
